/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Person(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Circle cx={127.88745} cy={44} r={36} />
        <Path d="M211.67456,139.51367,172.34448,88.94629a7.93269,7.93269,0,0,0-.65723-.74512A27.81868,27.81868,0,0,0,151.88745,80h-48a27.81872,27.81872,0,0,0-19.79981,8.20117,7.93259,7.93259,0,0,0-.65722.74512L44.09936,139.51416A20.00055,20.00055,0,0,0,72.37378,167.7876l14.09961-10.96729-19.832,62.64014a20.00009,20.00009,0,0,0,36.23731,16.897l25.00879-39.35937,25.00879,39.35937a20.00007,20.00007,0,0,0,36.2373-16.897l-19.832-62.64014,14.09961,10.96729a20.00035,20.00035,0,0,0,28.27344-28.27393Z" />
      </G>
    </Svg>
  );
}

export default Person;
